import { useSelector } from 'react-redux'

import { canSeePrices, isUserLoggedIn } from '../../redux/user/selectors'

type PriceVisibilityProps = {
  showPriceForAnonymousUser?: boolean
}

export const PriceVisibility: React.FC<PriceVisibilityProps> = ({ children, showPriceForAnonymousUser = true }) => {
  const showPrices = useSelector(canSeePrices)
  const isUserLoggedInVal = useSelector(isUserLoggedIn)

  if (isUserLoggedInVal) {
    if (!showPrices) return null
    return <>{children}</>
  } else {
    if (!showPriceForAnonymousUser) return null
    return <>{children}</>
  }
}
